<template>
  <a-carousel autoplay :autoplaySpeed="4000" style="height: 60vh;" :dots="false" effect="fade">
    <div v-for="(item, index) in enterprise.items" :key="index">
      <div class="index_enterprise_owner">
        <img :src="item.picture_owner" style="margin-top: 10vh">
        <div class="index_enterprise_owner_text">
          <p style="font-size: 22px;margin-bottom: 10px">Portfolio</p>
          <p style="font-size: 18px;margin-bottom: 0">{{ item.name_en }}</p>
          <p style="font-size: 18px">{{ item.owner_en }}</p>
          <a-button type="ghost" style="margin-top: 1vh">
            <router-link :to="'/enterprise'" @click.passive="backtotop">See More Portfolio</router-link>
          </a-button>
        </div>
      </div>
    </div>
  </a-carousel>
  <a-carousel autoplay :autoplaySpeed="4000" style="height: 40vh;" :dots="false" effect="fade">
    <div v-for="(item, index) in enterprise.items" :key="index">
      <div class="index_enterprise_introduction">
        <div style="margin:0 2vw ;text-align: center; padding-top: 8vh">
          <p style="font-size: 28px;margin-bottom: 2vh">{{ item.name_en }}</p>
          <p style="font-size: 12px">{{ item.introduction_en }}</p>
        </div>
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined/>
          </template>
        </a-button>
      </div>
    </div>
  </a-carousel>

</template>

<script>
import {reactive, onMounted} from 'vue'
import axios from "axios";
import {DownOutlined, LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons-vue/";


export default {
  name: 'Index_enterprise_en_m',
  components: {DownOutlined, LeftCircleOutlined, RightCircleOutlined},
  setup() {
    const enterprise = reactive({
      items: []
    })
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    onMounted(() => {   //调用展示于首页的企业信息
      axios.get('http://161.117.189.36:8081/api/enterprise/index')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {  //抓取所有数据
              enterprise.items.push(res.data[i])
            }
            for (let i = 0; i < enterprise.items.length; i++) {  //给图片资源添加前缀
              enterprise.items[i]["trademark"] = 'http://161.117.189.36' + enterprise.items[i]["trademark"]
              enterprise.items[i]["picture_owner"] = 'http://161.117.189.36' + enterprise.items[i]["picture_owner"]
            }
          })
    })
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    return {enterprise, next_page, backtotop}

  }
}

</script>
<style scoped>
/*有跑马灯组件需要使用scoped-*/
img {
  width: 100vw;
  height: 100vw;
  filter: brightness(80%);
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_introduction) {
  background-image: url("../../../assets/background/index_enterprise.jpg");
  height: 40vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_owner_text) {
  position: absolute;
  z-index: 2;
  text-align: left;
  padding-left: 5vw;
  padding-top: 24vh;
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_owner) {
  background-image: url("../../../assets/background/index_enterprise.jpg");
  width: 100vw;
  height: 60vh;
  display: flex;
}


</style>